<template>
  <q-expansion-item
    ref="fuelEconomy"
    :disabled="disabled"
    expand-icon="arrow_drop_down"
    expand-separator
    header-class="q-px-none bg-grey-3"
    @after-show="$refs.fuelEconomy.$el.scrollIntoView()"
  >
    <template v-slot:header>
      <div class="q-item__section column q-item__section--main justify-center" style="padding:3px 12px">
        <div class="q-item__label q-item__label--caption text-caption">Fuel Economy</div>
        <div class="q-item__label">
          <span v-if="!formData.economy && !formData.type">Not set</span>
          <span v-if="formData.economy">{{ formData.economy | fuelEconomyLocalized(formData.economyUm) }}</span>
          <span v-if="formData.economy && formData.type"> with </span>
          <span v-if="formData.type">{{ formData.type | capitalize }}</span>
        </div>
      </div>
    </template>
    <q-card>
      <q-card-section>
        <q-input
          v-model="formData.economy"
          autofocus
          class="q-mb-sm"
          filled
          label="Fuel Economy Value"
          @input="onInput"
        />
        <q-select
          v-model="formData.economyUm"
          v-capacitor-native-select
          class="q-mb-sm"
          display-value-sanitize
          emit-value
          filled
          label="Fuel Economy Unit"
          :options="availableUms"
          options-sanitize
          @input="onInput"
        />
        <q-select
          v-model="formData.type"
          v-capacitor-native-select
          display-value-sanitize
          emit-value
          filled
          label="Fuel Type"
          :options="avialableTypes"
          options-sanitize
          @input="onInput"
        />
      </q-card-section>
    </q-card>
  </q-expansion-item>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    disabled: Boolean,
    economy: Number,
    economyUm: String,
    type: String,
    value: String,
  },
  computed: {
    ...mapGetters('session', ['fuelTypes']),
    avialableTypes() {
      return [
        {
          label: 'None selected',
          value: '',
        },
        ...this.fuelTypes.map((type) => ({
          label: type,
          value: type,
        })),
      ];
    },
    availableUms() {
      return [
        {
          label: 'None Selected',
          value: '',
        },
        {
          label: 'mpg',
          value: 'mpg',
        },
        {
          label: 'km/L',
          value: 'km/L',
        },
        {
          label: 'L/100 km',
          value: 'L/100 km',
        },
      ];
    },
  },
  data() {
    return {
      formData: {
        economy: null,
        economyUm: '',
        type: '',
      },
    };
  },
  methods: {
    onInput() {
      this.$emit('input', {
        ...this.formData,
      });
    },
  },
  mounted() {
    const { economy, economyUm, type } = this;
    this.formData = { economy: economy || '', economyUm: economyUm || '', type: type || '' };
  },
};
</script>

<style lang="stylus" scoped>
/deep/ .q-item {
  padding: 8px 12px 8px 0px;
}
</style>
